module.exports = __webpack_public_path__ + "static/media/bg-light-icon.7f87a644.svg";